import cls from 'classnames';

import useStyles from './styles';
import { IAppSwitcherProps } from './types';
import AppSwitcherItem from './AppSwitcherItem';

export default function AppSwitcher({
  data,
  className,
  firstItem,
  lastItem,
  selected,
  onItemClick,
  queryData,
}: IAppSwitcherProps) {
  const classes = useStyles();

  return (
    <div className={cls(classes.root, className)}>
      <div className={classes.scrollable}>
        <div className={classes.container}>
          {firstItem && <div className={classes.marginItem}>{firstItem}</div>}
          <div className={classes.items}>
            {data.map(({ value, text, tooltip, url }) => (
              <AppSwitcherItem
                key={value}
                value={value}
                text={text}
                tooltip={tooltip}
                url={url}
                isSelected={selected === value}
                onItemClick={onItemClick}
                queryData={queryData}
              />
            ))}
          </div>
          {lastItem && <div className={classes.marginItem}>{lastItem}</div>}
        </div>
      </div>
    </div>
  );
}
